export type NotationStandard = {
  id: string;
  label: string;
  shapeId: string;
  category?: string;
  color?: string;
  icon?: string;
};

export const standards = {
  custom: {
    id: 'custom',
    shapeId: '',
    label: 'Custom',
    icon: '',
    category: undefined,
    color: undefined,
  },
  'ardoq-state': {
    id: 'ardoq-state',
    shapeId: 'state',
    label: 'State',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'ardoq-decision': {
    id: 'ardoq-decision',
    shapeId: 'decision',
    label: 'Decision',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'ardoq-item': {
    id: 'ardoq-item',
    shapeId: 'item',
    label: 'Item',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'ardoq-result': {
    id: 'ardoq-result',
    shapeId: 'result',
    label: 'Result',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'ardoq-terminal': {
    id: 'ardoq-terminal',
    shapeId: 'terminal',
    label: 'Terminal',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'ardoq-inputOutput': {
    id: 'ardoq-inputOutput',
    shapeId: 'inputOutput',
    label: 'Input/Output',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'ardoq-process': {
    id: 'ardoq-process',
    shapeId: 'process',
    label: 'Process',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'ardoq-predefinedProcess': {
    id: 'ardoq-predefinedProcess',
    shapeId: 'predefinedProcess',
    label: 'Predefined Process',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'ardoq-preparation': {
    id: 'ardoq-preparation',
    shapeId: 'preparation',
    label: 'Preparation',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'ardoq-connection': {
    id: 'ardoq-connection',
    shapeId: 'connection',
    label: 'Connection',
    category: 'Ardoq',
    color: undefined,
    icon: undefined,
  },
  'application-component': {
    id: 'application-component',
    shapeId: 'archimate-rect-component',
    label: 'Application (Component)',
    category: 'ArchiMate',
    color: '#51AEF0',
    icon: 'archimate-component-icon',
  },
  'application-collaboration': {
    id: 'application-collaboration',
    shapeId: 'archimate-rect-collaboration',
    label: 'Application (Collaboration)',
    category: 'ArchiMate',
    color: '#51AEF0',
    icon: 'archimate-collaboration-icon',
  },
  'application-interface': {
    id: 'application-interface',
    shapeId: 'archimate-rect-interface',
    label: 'Application (Interface)',
    category: 'ArchiMate',
    color: '#51AEF0',
    icon: 'archimate-interface-icon',
  },
  'application-function': {
    id: 'application-function',
    shapeId: 'archimate-rounded-rect-function',
    label: 'Application (Function)',
    category: 'ArchiMate',
    color: '#51AEF0',
    icon: 'archimate-function-icon',
  },

  'application-interaction': {
    id: 'application-interaction',
    shapeId: 'archimate-rounded-rect-interaction',
    label: 'Application (Interaction)',
    category: 'ArchiMate',
    color: '#51AEF0',
    icon: 'archimate-interaction-icon',
  },
  'application-process': {
    id: 'application-process',
    shapeId: 'archimate-rounded-rect-process',
    label: 'Application (Process)',
    category: 'ArchiMate',
    color: '#51AEF0',
    icon: 'archimate-process-icon',
  },
  'application-event': {
    id: 'application-event',
    shapeId: 'archimate-rounded-rect-event',
    label: 'Application (Event)',
    category: 'ArchiMate',
    color: '#51AEF0',
    icon: 'archimate-event-icon',
  },
  'application-service': {
    id: 'application-service',
    shapeId: 'archimate-rounded-rect-service',
    label: 'Application (Service)',
    category: 'ArchiMate',
    color: '#51AEF0',
    icon: 'archimate-service-icon',
  },
  'application-data': {
    id: 'application-data',
    shapeId: 'archimate-object',
    label: 'Application (Data Object)',
    category: 'ArchiMate',
    color: '#51AEF0',
    icon: 'archimate-object-icon',
  },
  'bpmn-ad-hoc-marker': {
    id: 'bpmn-ad-hoc-marker',
    shapeId: 'bpmn-ad-hoc-marker',
    label: 'BPMN Ad Hoc Marker',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-ad-hoc-marker-icon',
  },
  'bpmn-business-rule': {
    id: 'bpmn-business-rule',
    shapeId: 'bpmn-business-rule',
    label: 'BPMN Business Rule',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-business-rule-icon',
  },
  'bpmn-business-rule-task': {
    id: 'bpmn-business-rule-task',
    shapeId: 'bpmn-business-rule-task',
    label: 'BPMN Business Rule Task',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-business-rule-task-icon',
  },
  'bpmn-call-activity': {
    id: 'bpmn-call-activity',
    shapeId: 'bpmn-call-activity',
    label: 'BPMN Call Activity',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-call-activity-icon',
  },
  'bpmn-compensation-marker': {
    id: 'bpmn-compensation-marker',
    shapeId: 'bpmn-compensation-marker',
    label: 'BPMN Compensation Marker',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-compensation-marker-icon',
  },
  'bpmn-data-input': {
    id: 'bpmn-data-input',
    shapeId: 'bpmn-data-input',
    label: 'BPMN Data Input',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-data-input-icon',
  },
  'bpmn-data-object': {
    id: 'bpmn-data-object',
    shapeId: 'bpmn-data-object',
    label: 'BPMN Data Object',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-data-object-icon',
  },
  'bpmn-data-output': {
    id: 'bpmn-data-output',
    shapeId: 'bpmn-data-output',
    label: 'BPMN Data Output',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-data-output-icon',
  },
  'bpmn-data-store': {
    id: 'bpmn-data-store',
    shapeId: 'bpmn-data-store',
    label: 'BPMN Data Store',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-data-store-icon',
  },
  'bpmn-end-event': {
    id: 'bpmn-end-event',
    shapeId: 'bpmn-end-event',
    label: 'BPMN End Event',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-icon',
  },
  'bpmn-end-event-cancel': {
    id: 'bpmn-end-event-cancel',
    shapeId: 'bpmn-end-event-cancel',
    label: 'BPMN End Event Cancel',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-cancel-icon',
  },
  'bpmn-end-event-compensation': {
    id: 'bpmn-end-event-compensation',
    shapeId: 'bpmn-end-event-compensation',
    label: 'BPMN End Event Compensation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-compensation-icon',
  },
  'bpmn-end-event-error': {
    id: 'bpmn-end-event-error',
    shapeId: 'bpmn-end-event-error',
    label: 'BPMN End Event Error',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-error-icon',
  },
  'bpmn-end-event-message': {
    id: 'bpmn-end-event-message',
    shapeId: 'bpmn-end-event-message',
    label: 'BPMN End Event Message',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-message-icon',
  },
  'bpmn-end-event-escalation': {
    id: 'bpmn-end-event-escalation',
    shapeId: 'bpmn-end-event-escalation',
    label: 'BPMN End Event Escalation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-escalation-icon',
  },
  'bpmn-end-event-link': {
    id: 'bpmn-end-event-link',
    shapeId: 'bpmn-end-event-link',
    label: 'BPMN End Event Link',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-link-icon',
  },
  'bpmn-end-event-multiple': {
    id: 'bpmn-end-event-multiple',
    shapeId: 'bpmn-end-event-multiple',
    label: 'BPMN End Event Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-multiple-icon',
  },
  'bpmn-end-event-signal': {
    id: 'bpmn-end-event-signal',
    shapeId: 'bpmn-end-event-signal',
    label: 'BPMN End Event Signal',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-signal-icon',
  },
  'bpmn-end-event-terminate': {
    id: 'bpmn-end-event-terminate',
    shapeId: 'bpmn-end-event-terminate',
    label: 'BPMN End Event Terminate',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-end-event-terminate-icon',
  },
  'bpmn-intermediate-event': {
    id: 'bpmn-intermediate-event',
    shapeId: 'bpmn-intermediate-event',
    label: 'BPMN Intermediate Event',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-icon',
  },
  'bpmn-intermediate-event-catch-cancel': {
    id: 'bpmn-intermediate-event-catch-cancel',
    shapeId: 'bpmn-intermediate-event-catch-cancel',
    label: 'BPMN Intermediate Event Catch Cancel',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-cancel-icon',
  },
  'bpmn-intermediate-event-catch-compensation': {
    id: 'bpmn-intermediate-event-catch-compensation',
    shapeId: 'bpmn-intermediate-event-catch-compensation',
    label: 'BPMN Intermediate Event Catch Compensation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-compensation-icon',
  },
  'bpmn-intermediate-event-catch-condition': {
    id: 'bpmn-intermediate-event-catch-condition',
    shapeId: 'bpmn-intermediate-event-catch-condition',
    label: 'BPMN Intermediate Event Catch Condition',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-condition-icon',
  },
  'bpmn-intermediate-event-catch-error': {
    id: 'bpmn-intermediate-event-catch-error',
    shapeId: 'bpmn-intermediate-event-catch-error',
    label: 'BPMN Intermediate Event Catch Error',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-error-icon',
  },
  'bpmn-intermediate-event-catch-escalation': {
    id: 'bpmn-intermediate-event-catch-escalation',
    shapeId: 'bpmn-intermediate-event-catch-escalation',
    label: 'BPMN Intermediate Event Catch Escalation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-escalation-icon',
  },
  'bpmn-intermediate-event-catch-link': {
    id: 'bpmn-intermediate-event-catch-link',
    shapeId: 'bpmn-intermediate-event-catch-link',
    label: 'BPMN Intermediate Event Catch Link',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-link-icon',
  },
  'bpmn-intermediate-event-catch-message': {
    id: 'bpmn-intermediate-event-catch-message',
    shapeId: 'bpmn-intermediate-event-catch-message',
    label: 'BPMN Intermediate Event Catch Message',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-message-icon',
  },
  'bpmn-intermediate-event-catch-multiple': {
    id: 'bpmn-intermediate-event-catch-multiple',
    shapeId: 'bpmn-intermediate-event-catch-multiple',
    label: 'BPMN Intermediate Event Catch Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-multiple-icon',
  },
  'bpmn-intermediate-event-catch-non-interrupting-escalation': {
    id: 'bpmn-intermediate-event-catch-non-interrupting-escalation',
    shapeId: 'bpmn-intermediate-event-catch-non-interrupting-escalation',
    label: 'BPMN Intermediate Event Catch Non Interrupting Escalation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-non-interrupting-escalation-icon',
  },
  'bpmn-intermediate-event-catch-non-interrupting-message': {
    id: 'bpmn-intermediate-event-catch-non-interrupting-message',
    shapeId: 'bpmn-intermediate-event-catch-non-interrupting-message',
    label: 'BPMN Intermediate Event Catch Non Interrupting Message',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-non-interrupting-message-icon',
  },
  'bpmn-intermediate-event-catch-non-interrupting-multiple': {
    id: 'bpmn-intermediate-event-catch-non-interrupting-multiple',
    shapeId: 'bpmn-intermediate-event-catch-non-interrupting-multiple',
    label: 'BPMN Intermediate Event Catch Non Interrupting Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-non-interrupting-multiple-icon',
  },
  'bpmn-intermediate-event-catch-non-interrupting-parallel-multiple': {
    id: 'bpmn-intermediate-event-catch-non-interrupting-parallel-multiple',
    shapeId: 'bpmn-intermediate-event-catch-non-interrupting-parallel-multiple',
    label: 'BPMN Intermediate Event Catch Non Interrupting Parallel Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-non-interrupting-parallel-multiple-icon',
  },
  'bpmn-intermediate-event-catch-non-interrupting-signal': {
    id: 'bpmn-intermediate-event-catch-non-interrupting-signal',
    shapeId: 'bpmn-intermediate-event-catch-non-interrupting-signal',
    label: 'BPMN Intermediate Event Catch Non Interrupting Signal',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-non-interrupting-signal-icon',
  },
  'bpmn-intermediate-event-catch-non-interrupting-timer': {
    id: 'bpmn-intermediate-event-catch-non-interrupting-timer',
    shapeId: 'bpmn-intermediate-event-catch-non-interrupting-timer',
    label: 'BPMN Intermediate Event Catch Non Interrupting Timer',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-non-interrupting-timer-icon',
  },
  'bpmn-intermediate-event-catch-parallel-multiple': {
    id: 'bpmn-intermediate-event-catch-parallel-multiple',
    shapeId: 'bpmn-intermediate-event-catch-parallel-multiple',
    label: 'BPMN Intermediate Event Catch Parallel Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-parallel-multiple-icon',
  },
  'bpmn-intermediate-event-catch-signal': {
    id: 'bpmn-intermediate-event-catch-signal',
    shapeId: 'bpmn-intermediate-event-catch-signal',
    label: 'BPMN Intermediate Event Catch Signal',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-signal-icon',
  },
  'bpmn-intermediate-event-catch-timer': {
    id: 'bpmn-intermediate-event-catch-timer',
    shapeId: 'bpmn-intermediate-event-catch-timer',
    label: 'BPMN Intermediate Event Catch Timer',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-catch-timer-icon',
  },
  'bpmn-intermediate-event-non-interrupting': {
    id: 'bpmn-intermediate-event-non-interrupting',
    shapeId: 'bpmn-intermediate-event-non-interrupting',
    label: 'BPMN Intermediate Event Non Interrupting',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-non-interrupting-icon',
  },
  'bpmn-intermediate-event-throw-compensation': {
    id: 'bpmn-intermediate-event-throw-compensation',
    shapeId: 'bpmn-intermediate-event-throw-compensation',
    label: 'BPMN Intermediate Event Throw Compensation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-throw-compensation-icon',
  },
  'bpmn-intermediate-event-throw-escalation': {
    id: 'bpmn-intermediate-event-throw-escalation',
    shapeId: 'bpmn-intermediate-event-throw-escalation',
    label: 'BPMN Intermediate Event Throw Escalation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-throw-escalation-icon',
  },
  'bpmn-intermediate-event-throw-link': {
    id: 'bpmn-intermediate-event-throw-link',
    shapeId: 'bpmn-intermediate-event-throw-link',
    label: 'BPMN Intermediate Event Throw Link',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-throw-link-icon',
  },
  'bpmn-intermediate-event-throw-message': {
    id: 'bpmn-intermediate-event-throw-message',
    shapeId: 'bpmn-intermediate-event-throw-message',
    label: 'BPMN Intermediate Event Throw Message',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-throw-message-icon',
  },
  'bpmn-intermediate-event-throw-multiple': {
    id: 'bpmn-intermediate-event-throw-multiple',
    shapeId: 'bpmn-intermediate-event-throw-multiple',
    label: 'BPMN Intermediate Event Throw Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-throw-multiple-icon',
  },
  'bpmn-intermediate-event-throw-signal': {
    id: 'bpmn-intermediate-event-throw-signal',
    shapeId: 'bpmn-intermediate-event-throw-signal',
    label: 'BPMN Intermediate Event Throw Signal',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-intermediate-event-throw-signal-icon',
  },
  'bpmn-loop-marker': {
    id: 'bpmn-loop-marker',
    shapeId: 'bpmn-loop-marker',
    label: 'BPMN Loop Marker',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-loop-marker-icon',
  },

  'bpmn-manual': {
    id: 'bpmn-manual',
    shapeId: 'bpmn-manual',
    label: 'BPMN Manual',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-manual-icon',
  },

  'bpmn-manual-task': {
    id: 'bpmn-manual-task',
    shapeId: 'bpmn-manual-task',
    label: 'BPMN Manual Task',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-manual-task-icon',
  },
  'bpmn-parallel-mi-marker': {
    id: 'bpmn-parallel-mi-marker',
    shapeId: 'bpmn-parallel-mi-marker',
    label: 'BPMN Parallel Mi Marker',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-parallel-mi-marker-icon',
  },
  'bpmn-receive': {
    id: 'bpmn-receive',
    shapeId: 'bpmn-receive',
    label: 'BPMN Receive',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-receive-icon',
  },

  'bpmn-receive-task': {
    id: 'bpmn-receive-task',
    shapeId: 'bpmn-receive-task',
    label: 'BPMN Receive Task',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-receive-task-icon',
  },

  'bpmn-script': {
    id: 'bpmn-script',
    shapeId: 'bpmn-script',
    label: 'BPMN Script',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-script-icon',
  },

  'bpmn-script-task': {
    id: 'bpmn-script-task',
    shapeId: 'bpmn-script-task',
    label: 'BPMN Script Task',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-script-task-icon',
  },

  'bpmn-send': {
    id: 'bpmn-send',
    shapeId: 'bpmn-send',
    label: 'BPMN Send',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-send-icon',
  },

  'bpmn-send-task': {
    id: 'bpmn-send-task',
    shapeId: 'bpmn-send-task',
    label: 'BPMN Send Task',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-send-task-icon',
  },

  'bpmn-sequential-mi-marker': {
    id: 'bpmn-sequential-mi-marker',
    shapeId: 'bpmn-sequential-mi-marker',
    label: 'BPMN Sequential Mi Marker',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-sequential-mi-marker-icon',
  },

  'bpmn-service': {
    id: 'bpmn-service',
    shapeId: 'bpmn-service',
    label: 'BPMN Service',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-service-icon',
  },

  'bpmn-service-task': {
    id: 'bpmn-service-task',
    shapeId: 'bpmn-service-task',
    label: 'BPMN Service Task',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-service-task-icon',
  },

  'bpmn-start-event': {
    id: 'bpmn-start-event',
    shapeId: 'bpmn-start-event',
    label: 'BPMN Start Event',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-icon',
  },

  'bpmn-start-event-compensation': {
    id: 'bpmn-start-event-compensation',
    shapeId: 'bpmn-start-event-compensation',
    label: 'BPMN Start Event Compensation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-compensation-icon',
  },

  'bpmn-start-event-condition': {
    id: 'bpmn-start-event-condition',
    shapeId: 'bpmn-start-event-condition',
    label: 'BPMN Start Event Condition',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-condition-icon',
  },

  'bpmn-start-event-error': {
    id: 'bpmn-start-event-error',
    shapeId: 'bpmn-start-event-error',
    label: 'BPMN Start Event Error',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-error-icon',
  },

  'bpmn-start-event-escalation': {
    id: 'bpmn-start-event-escalation',
    shapeId: 'bpmn-start-event-escalation',
    label: 'BPMN Start Event Escalation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-escalation-icon',
  },

  'bpmn-start-event-message': {
    id: 'bpmn-start-event-message',
    shapeId: 'bpmn-start-event-message',
    label: 'BPMN Start Event Message',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-message-icon',
  },

  'bpmn-start-event-multiple': {
    id: 'bpmn-start-event-multiple',
    shapeId: 'bpmn-start-event-multiple',
    label: 'BPMN Start Event Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-multiple-icon',
  },

  'bpmn-start-event-non-interrupting': {
    id: 'bpmn-start-event-non-interrupting',
    shapeId: 'bpmn-start-event-non-interrupting',
    label: 'BPMN Start Event Non Interrupting',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-non-interrupting-icon',
  },

  'bpmn-start-event-non-interrupting-condition': {
    id: 'bpmn-start-event-non-interrupting-condition',
    shapeId: 'bpmn-start-event-non-interrupting-condition',
    label: 'BPMN Start Event Non Interrupting Condition',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-non-interrupting-condition-icon',
  },

  'bpmn-start-event-non-interrupting-escalation': {
    id: 'bpmn-start-event-non-interrupting-escalation',
    shapeId: 'bpmn-start-event-non-interrupting-escalation',
    label: 'BPMN Start Event Non Interrupting Escalation',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-non-interrupting-escalation-icon',
  },
  'bpmn-start-event-non-interrupting-message': {
    id: 'bpmn-start-event-non-interrupting-message',
    shapeId: 'bpmn-start-event-non-interrupting-message',
    label: 'BPMN Start Event Non Interrupting Message',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-non-interrupting-message-icon',
  },
  'bpmn-start-event-non-interrupting-multiple': {
    id: 'bpmn-start-event-non-interrupting-multiple',
    shapeId: 'bpmn-start-event-non-interrupting-multiple',
    label: 'BPMN Start Event Non Interrupting Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-non-interrupting-multiple-icon',
  },

  'bpmn-start-event-non-interrupting-parallel-multiple': {
    id: 'bpmn-start-event-non-interrupting-parallel-multiple',
    shapeId: 'bpmn-start-event-non-interrupting-parallel-multiple',
    label: 'BPMN Start Event Non Interrupting Parallel Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-non-interrupting-parallel-multiple-icon',
  },
  'bpmn-start-event-non-interrupting-signal': {
    id: 'bpmn-start-event-non-interrupting-signal',
    shapeId: 'bpmn-start-event-non-interrupting-signal',
    label: 'BPMN Start Event Non Interrupting Signal',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-non-interrupting-signal-icon',
  },
  'bpmn-start-event-non-interrupting-timer': {
    id: 'bpmn-start-event-non-interrupting-timer',
    shapeId: 'bpmn-start-event-non-interrupting-timer',
    label: 'BPMN Start Event Non Interrupting Timer',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-non-interrupting-timer-icon',
  },
  'bpmn-start-event-parallel-multiple': {
    id: 'bpmn-start-event-parallel-multiple',
    shapeId: 'bpmn-start-event-parallel-multiple',
    label: 'BPMN Start Event Parallel Multiple',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-parallel-multiple-icon',
  },
  'bpmn-start-event-signal': {
    id: 'bpmn-start-event-signal',
    shapeId: 'bpmn-start-event-signal',
    label: 'BPMN Start Event Signal',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-signal-icon',
  },
  'bpmn-start-event-timer': {
    id: 'bpmn-start-event-timer',
    shapeId: 'bpmn-start-event-timer',
    label: 'BPMN Start Event Timer',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-start-event-timer-icon',
  },
  'bpmn-gateway': {
    id: 'bpmn-gateway',
    shapeId: 'bpmn-gateway',
    label: 'BPMN Gateway',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-gateway-icon',
  },
  'bpmn-gateway-complex': {
    id: 'bpmn-gateway-complex',
    shapeId: 'bpmn-gateway-complex',
    label: 'BPMN Gateway Complex',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-gateway-complex-icon',
  },
  'bpmn-gateway-eventbased': {
    id: 'bpmn-gateway-eventbased',
    shapeId: 'bpmn-gateway-eventbased',
    label: 'BPMN Gateway Eventbased',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-gateway-eventbased-icon',
  },
  'bpmn-gateway-or': {
    id: 'bpmn-gateway-or',
    shapeId: 'bpmn-gateway-or',
    label: 'BPMN Gateway Or',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-gateway-or-icon',
  },
  'bpmn-gateway-parallel': {
    id: 'bpmn-gateway-parallel',
    shapeId: 'bpmn-gateway-parallel',
    label: 'BPMN Gateway Parallel',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-gateway-parallel-icon',
  },
  'bpmn-gateway-xor': {
    id: 'bpmn-gateway-xor',
    shapeId: 'bpmn-gateway-xor',
    label: 'BPMN Gateway Xor',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-gateway-xor-icon',
  },
  'bpmn-subprocess-expanded': {
    id: 'bpmn-subprocess-expanded',
    shapeId: 'bpmn-subprocess-expanded',
    label: 'BPMN Subprocess Expanded',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-subprocess-expanded-icon',
  },
  'bpmn-subprocess-collapsed': {
    id: 'bpmn-subprocess-collapsed',
    shapeId: 'bpmn-subprocess-collapsed',
    label: 'BPMN Subprocess Collapsed',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-subprocess-collapsed-icon',
  },
  'bpmn-task': {
    id: 'bpmn-task',
    shapeId: 'bpmn-task',
    label: 'BPMN Task',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-task-icon',
  },
  'bpmn-transaction': {
    id: 'bpmn-transaction',
    shapeId: 'bpmn-transaction',
    label: 'BPMN Transaction',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-transaction-icon',
  },
  'bpmn-user': {
    id: 'bpmn-user',
    shapeId: 'bpmn-user',
    label: 'BPMN User',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-user-icon',
  },
  'bpmn-user-task': {
    id: 'bpmn-user-task',
    shapeId: 'bpmn-user-task',
    label: 'BPMN User Task',
    color: '#626262',
    category: 'BPMN',
    icon: 'bpmn-user-task-icon',
  },
  'business-role': {
    id: 'business-role',
    shapeId: 'archimate-rect-role',
    label: 'Business (Role)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-role-icon',
  },
  'business-actor': {
    id: 'business-actor',
    shapeId: 'archimate-rect-actor',
    label: 'Business (Actor)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-actor-icon',
  },
  'business-collaboration': {
    id: 'business-collaboration',
    shapeId: 'archimate-rect-collaboration',
    label: 'Business (Collaboration)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-collaboration-icon',
  },
  'business-interface': {
    id: 'business-interface',
    shapeId: 'archimate-rect-interface',
    label: 'Business (Interface)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-interaction-icon',
  },
  'business-process': {
    id: 'business-process',
    shapeId: 'archimate-rounded-rect-process',
    label: 'Business (Process)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-process-icon',
  },
  'business-function': {
    id: 'business-function',
    shapeId: 'archimate-rounded-rect-function',
    label: 'Business (Function)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-function-icon',
  },
  'business-event': {
    id: 'business-event',
    shapeId: 'archimate-rounded-rect-event',
    label: 'Business (Event)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-event-icon',
  },
  'business-service': {
    id: 'business-service',
    shapeId: 'archimate-rounded-rect-service',
    label: 'Business (Service)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-service-icon',
  },
  'business-object': {
    id: 'business-object',
    shapeId: 'archimate-object',
    label: 'Business (Object)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-object-icon',
  },
  'business-contract': {
    id: 'business-contract',
    shapeId: 'archimate-contract',
    label: 'Business (Contract)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-object-icon',
  },
  'business-representation': {
    id: 'business-representation',
    shapeId: 'archimate-representation',
    label: 'Business (Representation)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-representation-icon',
  },
  'business-product': {
    id: 'business-product',
    shapeId: 'archimate-product',
    label: 'Business (Product)',
    category: 'ArchiMate',
    color: '#ffbb3f',
    icon: 'archimate-product-icon',
  },
  'implementation-package': {
    id: 'implementation-package',
    shapeId: 'archimate-rounded-rect-service',
    label: 'Implementation (Work Package)',
    category: 'ArchiMate',
    color: '#d4acac',
    icon: 'archimate-service-icon',
  },
  'implementation-deliverable': {
    id: 'implementation-deliverable',
    shapeId: 'archimate-wave-rect',
    label: 'Implementation (Deliverable)',
    category: 'ArchiMate',
    color: '#d4acac',
    icon: 'archimate-wave-icon',
  },
  'implementation-event': {
    id: 'implementation-event',
    shapeId: 'archimate-rounded-rect-event',
    label: 'Implementation (Event)',
    category: 'ArchiMate',
    color: '#d4acac',
    icon: 'archimate-event-icon',
  },
  'implementation-plateau': {
    id: 'implementation-plateau',
    shapeId: 'archimate-3d-rect-plateau',
    label: 'Implementation (Plateau)',
    category: 'ArchiMate',
    color: '#94e328',
    icon: 'archimate-plateau-icon',
  },
  'implementation-gap': {
    id: 'implementation-gap',
    shapeId: 'archimate-wave-rect-gap',
    label: 'Implementation (Gap)',
    category: 'ArchiMate',
    color: '#94e328',
    icon: 'archimate-gap-icon',
  },
  'motivation-stakeholder': {
    id: 'motivation-stakeholder',
    shapeId: 'archimate-rounded-rect-stakeholder',
    label: 'Motivation (Stakeholder)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-stakeholder-icon',
  },
  'motivation-driver': {
    id: 'motivation-driver',
    shapeId: 'archimate-rounded-rect-driver',
    label: 'Motivation (Driver)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-driver-icon',
  },
  'motivation-assessment': {
    id: 'motivation-assessment',
    shapeId: 'archimate-rounded-rect-assessment',
    label: 'Motivation (Assessment)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-assessment-icon',
  },
  'motivation-goal': {
    id: 'motivation-goal',
    shapeId: 'archimate-rounded-rect-goal',
    label: 'Motivation (Goal)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-goal-icon',
  },
  'motivation-outcome': {
    id: 'motivation-outcome',
    shapeId: 'archimate-rounded-rect-outcome',
    label: 'Motivation (Outcome)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-outcome-icon',
  },
  'motivation-principle': {
    id: 'motivation-principle',
    shapeId: 'archimate-rounded-rect-principle',
    label: 'Motivation (Principle)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-principle-icon',
  },
  'motivation-requirement': {
    id: 'motivation-requirement',
    shapeId: 'archimate-rounded-rect-requirement',
    label: 'Motivation (Requirement)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-requirement-icon',
  },
  'motivation-constraint': {
    id: 'motivation-constraint',
    shapeId: 'archimate-rounded-rect-constraint',
    label: 'Motivation (Constraint)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-constraint-icon',
  },
  'motivation-meaning': {
    id: 'motivation-meaning',
    shapeId: 'archimate-cloud',
    label: 'Motivation (Meaning)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-cloud-icon',
  },
  'motivation-value': {
    id: 'motivation-value',
    shapeId: 'archimate-oval-circle',
    label: 'Motivation (Value)',
    category: 'ArchiMate',
    color: '#8989DA',
    icon: 'archimate-oval-circle-icon',
  },
  'physical-equipment': {
    id: 'physical-equipment',
    shapeId: 'archimate-3d-rect-equipment',
    label: 'Physical (Equipment)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-equipment-icon',
  },
  'physical-facility': {
    id: 'physical-facility',
    shapeId: 'archimate-3d-rect-facility',
    label: 'Physical (Facility)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-facility-icon',
  },
  'physical-distribution-network': {
    id: 'physical-distribution-network',
    shapeId: 'archimate-rect-distribution-network',
    label: 'Physical (Distribution Network)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-distribution-network-icon',
  },
  'physical-material': {
    id: 'physical-material',
    shapeId: 'archimate-rect-material',
    label: 'Physical (Material)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-material-icon',
  },
  'strategy-resource': {
    id: 'strategy-resource',
    shapeId: 'archimate-rect-resource',
    label: 'Strategy (Resource)',
    category: 'ArchiMate',
    color: '#d4912e',
    icon: 'archimate-resource-icon',
  },
  'strategy-capability': {
    id: 'strategy-capability',
    shapeId: 'archimate-rounded-rect-capability',
    label: 'Strategy (Capability)',
    category: 'ArchiMate',
    color: '#d4912e',
    icon: 'archimate-capability-icon',
  },
  'strategy-course-of-action': {
    id: 'strategy-course-of-action',
    shapeId: 'archimate-rounded-rect-course-of-action',
    label: 'Strategy (Course of Action)',
    category: 'ArchiMate',
    color: '#d4912e',
    icon: 'archimate-course-of-action-icon',
  },
  'strategy-value-stream': {
    id: 'strategy-value-stream',
    shapeId: 'archimate-rounded-rect-value-stream',
    label: 'Strategy (Value Stream)',
    category: 'ArchiMate',
    color: '#d4912e',
    icon: 'archimate-value-stream-icon',
  },
  'technology-node': {
    id: 'technology-node',
    shapeId: 'archimate-rect-node',
    label: 'Technology (Node)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-node-icon',
  },
  'technology-device': {
    id: 'technology-device',
    shapeId: 'archimate-3d-rect-device',
    label: 'Technology (Device)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-device-icon',
  },
  'technology-system-software': {
    id: 'technology-system-software',
    shapeId: 'archimate-rect-system-software',
    label: 'Technology (System Software)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-system-software-icon',
  },
  'technology-collaboration': {
    id: 'technology-collaboration',
    shapeId: 'archimate-rect-collaboration',
    label: 'Technology (Collaboration)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-collaboration-icon',
  },
  'technology-interface': {
    id: 'technology-interface',
    shapeId: 'archimate-rect-interface',
    label: 'Technology (Interface)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-interface-icon',
  },
  'technology-path': {
    id: 'technology-path',
    shapeId: 'archimate-rect-path',
    label: 'Technology (Path)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-path-icon',
  },
  'technology-communication-network': {
    id: 'technology-communication-network',
    shapeId: 'archimate-rect-communication-network',
    label: 'Technology (Communication Network)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-communication-network-icon',
  },
  'technology-function': {
    id: 'technology-function',
    shapeId: 'archimate-rounded-rect-function',
    label: 'Technology (Function)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-function-icon',
  },
  'technology-process': {
    id: 'technology-process',
    shapeId: 'archimate-rounded-rect-process',
    label: 'Technology (Process)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-process-icon',
  },
  'technology-interaction': {
    id: 'technology-interaction',
    shapeId: 'archimate-rounded-rect-interaction',
    label: 'Technology (Interaction)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-interaction-icon',
  },
  'technology-event': {
    id: 'technology-event',
    shapeId: 'archimate-rounded-rect-event',
    label: 'Technology (Event)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-event-icon',
  },
  'technology-service': {
    id: 'technology-service',
    shapeId: 'archimate-rounded-rect-service',
    label: 'Technology (Service)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-service-icon',
  },
  'technology-artifact': {
    id: 'technology-artifact',
    shapeId: 'archimate-rect-artifact',
    label: 'Technology (Artifact)',
    category: 'ArchiMate',
    color: '#1EB710',
    icon: 'archimate-artifact-icon',
  },
  location: {
    id: 'location',
    shapeId: 'archimate-rect-location',
    label: 'Location',
    category: 'ArchiMate',
    color: '#FF9832',
    icon: 'archimate-location-icon',
  },
  'junction-and': {
    id: 'junction-and',
    shapeId: 'archimate-and',
    label: 'Junction (And)',
    category: 'ArchiMate',
    icon: 'archimate-and-icon',
    color: '#000000',
  },
  'junction-or': {
    id: 'junction-or',
    shapeId: 'archimate-or',
    label: 'Junction (Or)',
    category: 'ArchiMate',
    icon: 'archimate-or-icon',
    color: '#000000',
  },
  'edgy-activity': {
    id: 'edgy-activity',
    shapeId: 'edgy-activity-shape',
    label: 'Edgy Activity',
    category: 'EDGY',
    icon: 'edgy-activity-icon',
    color: '#000000',
  },
  'edgy-asset': {
    id: 'edgy-asset',
    shapeId: 'edgy-asset-shape',
    label: 'EDGY Asset',
    category: 'EDGY',
    icon: 'edgy-asset-icon',
    color: '#2d60ad',
  },
  'edgy-brand': {
    id: 'edgy-brand',
    shapeId: 'edgy-brand-shape',
    label: 'EDGY Brand',
    category: 'EDGY',
    icon: 'edgy-brand-icon',
    color: '#faa72b',
  },
  'edgy-capability': {
    id: 'edgy-capability',
    shapeId: 'edgy-capability-shape',
    label: 'EDGY Capability',
    category: 'EDGY',
    icon: 'edgy-capability-icon',
    color: '#2d60ad',
  },
  'edgy-channel': {
    id: 'edgy-channel',
    shapeId: 'edgy-channel-shape',
    label: 'EDGY Channel',
    category: 'EDGY',
    icon: 'edgy-channel-icon',
    color: '#ee2e66',
  },
  'edgy-content': {
    id: 'edgy-content',
    shapeId: 'edgy-content-shape',
    label: 'EDGY Content',
    category: 'EDGY',
    icon: 'edgy-content-icon',
    color: '#5abb67',
  },
  'edgy-journey': {
    id: 'edgy-journey',
    shapeId: 'edgy-journey-shape',
    label: 'EDGY Journey',
    category: 'EDGY',
    icon: 'edgy-journey-icon',
    color: '#ee2e66',
  },
  'edgy-object': {
    id: 'edgy-object',
    shapeId: 'edgy-object-shape',
    label: 'EDGY Object',
    category: 'EDGY',
    icon: 'edgy-object-icon',
    color: '#000000',
  },
  'edgy-organisation': {
    id: 'edgy-organisation',
    shapeId: 'edgy-organisation-shape',
    label: 'EDGY Organisation',
    category: 'EDGY',
    icon: 'edgy-organisation-icon',
    color: '#1ec2e6',
  },
  'edgy-outcome': {
    id: 'edgy-outcome',
    shapeId: 'edgy-outcome-shape',
    label: 'EDGY Outcome',
    category: 'EDGY',
    icon: 'edgy-outcome-icon',
    color: '#000000',
  },
  'edgy-people': {
    id: 'edgy-people',
    shapeId: 'edgy-people-shape',
    label: 'EDGY People',
    category: 'EDGY',
    icon: 'edgy-people-icon',
    color: '#000000',
  },
  'edgy-process': {
    id: 'edgy-process',
    shapeId: 'edgy-process-shape',
    label: 'EDGY Process',
    category: 'EDGY',
    icon: 'edgy-process-icon',
    color: '#2d60ad',
  },
  'edgy-product': {
    id: 'edgy-product',
    shapeId: 'edgy-product-shape',
    label: 'EDGY Product',
    category: 'EDGY',
    icon: 'edgy-product-icon',
    color: '#8763aa',
  },
  'edgy-purpose': {
    id: 'edgy-purpose',
    shapeId: 'edgy-purpose-shape',
    label: 'EDGY Purpose',
    category: 'EDGY',
    icon: 'edgy-purpose-icon',
    color: '#5abb67',
  },
  'edgy-story': {
    id: 'edgy-story',
    shapeId: 'edgy-story-shape',
    label: 'EDGY Story',
    category: 'EDGY',
    icon: 'edgy-story-icon',
    color: '#5abb67',
  },
  'edgy-task': {
    id: 'edgy-task',
    shapeId: 'edgy-task-shape',
    label: 'EDGY Task',
    category: 'EDGY',
    icon: 'edgy-task-icon',
    color: '#ee2e66',
  },
} as const satisfies Record<string, NotationStandard>;
